import type { Static } from 'runtypes';
import { Literal, Record, String } from 'runtypes';
import { type BaseEvent, BaseEventRuntype } from './base';
import { CoreEventRuntype } from './core';
import { ClickstreamEventEnum } from 'bc-model';

const NoticeMutedBrowserRunType = BaseEventRuntype.And(
  Record({ noticeKey: String, noticeType: String, version: Literal(1) })
);
const NoticeMutedServerRunType = NoticeMutedBrowserRunType.And(CoreEventRuntype).And(
  Record({ sessionId: String })
);

type NoticeMutedBrowserEvent = Static<typeof NoticeMutedBrowserRunType>;
type NoticeMutedServerEvent = Static<typeof NoticeMutedServerRunType>;

const isNoticeMutedServerEvent = (obj: BaseEvent): obj is NoticeMutedServerEvent => {
  return obj.event === ClickstreamEventEnum.NOTICE_MUTED;
};

export {
  isNoticeMutedServerEvent,
  NoticeMutedBrowserRunType,
  NoticeMutedServerRunType,
  NoticeMutedBrowserEvent,
  NoticeMutedServerEvent,
};
